import { APIConfiguration } from '@savgroup-front-common/configuration';
import {
  COMMON_QUERY_PARAMS,
  SUPPORTED_METHODS,
} from '@savgroup-front-common/constants';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
  ClaimProductState,
  ReverseMoney,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.claim}claims/${COMMON_QUERY_PARAMS.CLAIM_ID}/solution`;

interface SetClaimSolutionPayload {
  claimId: string;
  solutionTypeId: string;
  solutionPrice?: ReverseMoney;
}

async function setClaimSolutionCommand({
  claimId,
  solutionTypeId,
  solutionPrice,
}: SetClaimSolutionPayload): Promise<
  BackResponse<ClaimProductState> | BackResponseFailure
> {
  try {
    const url = ENDPOINT.replace(COMMON_QUERY_PARAMS.CLAIM_ID, claimId);

    const response = await apiCall<BackResponse<ClaimProductState>>(url, {
      method: SUPPORTED_METHODS.PUT,
      json: {
        solutionTypeId,
        solutionPrice,
      },
    });

    return response;
  } catch (exception) {
    return prepareResponseFailure(exception);
  }
}

export default setClaimSolutionCommand;
